import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{
  readonly smallSpace?: boolean;
}>`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 180px auto 0 auto;
  ${({ smallSpace }) =>
    smallSpace &&
    css`
      margin-top: 20px;
    `}
`;

export const Icon = styled.div`
  max-width: 154.35px;
  min-width: 154.35px;
  max-height: 135.06px;
  min-height: 135.06px;
  margin-bottom: 35px;
  opacity: 0.4;
`;

export const Title = styled.h5`
  font-size: ${({ theme }) => theme.fontsizes.h5};
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.black2};
  margin-bottom: 30px;
  text-align: center;
`;

export const AddCar = styled.button`
  display: flex;
  align-items: center;
`;

export const AddButton = styled.button`
  width: 37.05px;
  height: 37.05px;
  border-radius: 50%;
  display: flex;
  /* align-items: center; */
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.brandColor};
  color: ${({ theme }) => theme.colors.white};
  margin-right: 48px;
  font-size: 2rem;
  line-height: 37px;
`;

export const P = styled.p`
  font-size: 3rem;
  font-weight: ${({ theme }) => theme.fontWeight.font800};
  color: ${({ theme }) => theme.colors.brandColor};
`;
